import { render, staticRenderFns } from "./CompetitionDetail.vue?vue&type=template&id=65cac976&scoped=true&"
import script from "./CompetitionDetail.vue?vue&type=script&lang=js&"
export * from "./CompetitionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cac976",
  null
  
)

export default component.exports